import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import Menu from '../components/Menu'
import NotesMenu from '../components/NotesMenu'
import Text from '../components/Text'
import patient from '../stores/patient'
import styled from 'styled-components'
import { observer } from 'mobx-react'
import PhoneSessionScript from '../components/PhoneSessionScript'


const TopBar = styled.div`
  background: #fff;
  border-bottom: 1px solid var(--light-gray);
  display: flex;
  position: fixed;
  height: 3.5rem;
  width: 100vw;
  font-weight: 300;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  z-index: 100;
`
const Wrap = styled.div`
	width: 100%;
	display: flex;
	position: absolute;
	z-index: 0;
	left: 50%;
	transform: translate(-50%, 0);
	height: calc(100% - 3.5rem);
	top: 3.5rem;
	overflow: hidden;
`

const RightContent = styled.div`
  flex: 1;
  padding: 1rem;
  overflow-y: auto;
  @media (max-width: 800px) {
	  padding: 1rem 2rem;
  }

`

const LeftContent = styled.div`
	flex: 1;
	padding: 1rem;
	overflow-y: auto;
	@media (max-width: 800px) {
		display: none;
	}
`

const Icon = styled.i`
  font-size: 1.5rem;
`

@observer
class PhoneSessionLayout extends Component {
  render() {
    const { title, children } = this.props

    return (
      <Fragment>
        <Menu icon="fas fa-bars">
          <Menu.Logo />
          <Menu.Divider />
			<Menu.LanguageSwitcher />
			{/* <Menu.QuitLink to={`/edit-patient/${patientID}`} str="titles.endSession" icon="fas fa-chevron-left" /> */}
        </Menu>
        <NotesMenu />
		<TopBar>
			{patient.updateScheduled &&
				<Icon className="fas fa-sync fa-spin" />
			}
			{!patient.updateScheduled && !patient.updateError && 
				<Text str={title} />
			}
			{!patient.updateScheduled && patient.updateError &&
				<Icon className="fas fa-exclamation-triangle" />
			}
		</TopBar>
		<Wrap>
			<LeftContent>
				<PhoneSessionScript />
				<div style={{ marginBottom: '1rem' }} />
			</LeftContent>
			<RightContent>
				{children}
				<div style={{ marginBottom: '1rem' }} />
			</RightContent>
		</Wrap>
      </Fragment>
    )
  }
}

export default withRouter(PhoneSessionLayout)



// WEBPACK FOOTER //
// ./src/layouts/PhoneSessionLayout.js